import { render, staticRenderFns } from "./IconDeliveryVan.vue?vue&type=template&id=72e5963d"
import script from "./IconDeliveryVan.vue?vue&type=script&lang=js"
export * from "./IconDeliveryVan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports